import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CreateRoutingInfoBody, RoutingsService } from '../../Services/API';
import { MutationKeys, QueryKeys } from '../types';

export const useCreateRouting = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.createRouting],
    async (params: CreateRoutingInfoBody) => {
      return RoutingsService.routingsControllerCreateRouting({ body: params });
    },
    {
      onSuccess: () => {
        toast.success('Le routage a été créé avec succès');
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchRoutings] });
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchUniqueColumnValues] });
      },
      onError: (error: AxiosError) => {
        if (error.response?.status === 403) {
          toast.error('Droits insuffisants pour créer des routages');
        } else if (error.response?.status === 422) {
          toast.error("Le siret n'a pas été trouvé");
        } else {
          toast.error('Une erreur est survenue lors de la création du routage');
        }
      },
    }
  );
};
